import React, { useEffect, useState } from 'react';
import Modal from 'src/component/Global/Modal';
import DisplayLongDescriptionAndVariantMFRName from 'src/component/Product/DisplayLongDescriptionAndVariantMFRName';
import { useCartStore } from 'src/hooks/cart';
import Helper from 'src/support/Helper';
import Common from '../Common';
import CartRepository from 'src/repository/CartRepository';
import NavigateToPDP from 'src/component/Global/Product/NavigateToPDP';

const CartPriceMisMatchBackOrder = (props) => {
    const [status, SetStatus] = useState(false);
    const { misMatchData = [], inventoryData = [] } = props.data;
    const [{ CART_DATA, CART_PRODUCT_DATA, CART_PRODUCT_INVENTORY_DATA }, { }, { ADD_TO_CART }] = useCartStore();
    // const [data, setData] = useState({ misMatchData: [], inventoryData: [] });

    // const getCartProductInventoryQuantityByERPPartNumber = (ERPPartNumber) => {
    //     return new Common().getCartProductInventoryQuantityByERPPartNumber(ERPPartNumber, CART_PRODUCT_INVENTORY_DATA);
    // };
    const getCartProductInventoryLeadTimeByERPPartNumber = (ERPPartNumber) => {
        return new Common().getCartProductInventoryLeadTimeByERPPartNumber(ERPPartNumber, CART_PRODUCT_INVENTORY_DATA);
    };


    useEffect(() => {
        SetStatus(true)
    }, []);

    const onHide = () => {
        SetStatus(false)
    };

    const updateQty = async () => {
        let d = [];
        // Note: Should First take inventory, because having backorder Qty, Do not update the sequence
        if (inventoryData.length) {
            inventoryData.map((v) => {
                d.push({
                    cartDetailId: v.cartDetailId,
                    quantity: v.adjustedQuantity,
                    backOrderedQuantity: v.adjustedQuantity, // check this senario which is having inventory Qty
                    erpMfrPartNumber: v.ERPMFRPartNumber,
                    itemNumber: v.ItemNumber,
                    manufacturerPartNumber: v.ManufacturerPartNumber,
                    manufacturerCode: v.manufacturerCode,
                    manufacturerName: v.manufacturerName,
                    assetURL: v.assetURL,
                    currency: v.currency,
                    // unitPrice: 0,
                    // subtotal: 0,
                    cpn: v.cpn,
                    manualCPN: v.manualCPN,
                    cpnType: v.cpnType,
                    erpManufacturerName: v.erpManufacturerName,
                    erpManufacturerCode: v.erpManufacturerCode,
                    hazardousFlag: v?.HazardousFlag
                });
            });
        }

        misMatchData.map((v) => {
            if (!v.invMsg) {
                d.push({
                    cartDetailId: v.cartDetailId,
                    quantity: v.adjustedQuantity,
                    ERPMFRPartNumber: v.ERPMFRPartNumber,
                    itemNumber: v.ItemNumber,
                    manufacturerPartNumber: v.ManufacturerPartNumber,
                    manufacturerCode: v.manufacturerCode,
                    manufacturerName: v.manufacturerName,
                    assetURL: v.assetURL,
                    currency: v.currency,
                    // unitPrice: 0,
                    // subtotal: 0,
                    cpn: v.cpn,
                    manualCPN: v.manualCPN,
                    cpnType: v.cpnType,
                    erpManufacturerName: v.erpManufacturerName,
                    erpManufacturerCode: v.erpManufacturerCode,
                    hazardousFlag: v?.HazardousFlag
                });
            }
        });


        if (d.length) {
            await new CartRepository().UpdateCartItemsServer(d, true, true)
        }
        onHide(false);
    }



    return (
        <Modal show={status} onHide={() => { onHide() }}>
            <div className="avnet-modal modal-680">
                <div className="avnet-modal-inner">
                    <button type="button" className="close" data-dismiss="modal"
                        onClick={() => { onHide() }}>×
                    </button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading">Price Mismatch
                            {inventoryData.length ? "and Inventory Alert" : ""}</h3>
                    </div>
                    <div className="m-4 mt-0 mb-0">
                        <div className="justify-content-start">
                            There is a mismatch between selected Quantity and the available price tier. <br />
                            We currently do not have sufficient inventory for the following item(s).<br />
                            Please contact your local sales officer for a lower quantity pricing.<br /> <br />

                            Confirm the adjusted quantity and backorder by clicking the <b>Yes</b> button below.
                            <br />
                            <b>Note:</b> you can always remove item(s) from cart after confirming adjustments
                        </div>
                    </div>
                    <div className="modal-body">
                        <div className="inventory-table price-mismatch-table">
                            <table className="table table-outline rounded-0">
                                <thead>
                                    <tr className="bg-light">
                                        <th colSpan={4} className='text-center'>Price Mismatch</th>
                                    </tr>
                                    <tr>
                                        <th className="border-0 text-none font-12">Product(s)</th>
                                        <th className="border-0 text-none font-12">Requested Qty</th>
                                        <th className="border-0 text-none font-12">Adjusted Qty</th>
                                        <th className="border-0 text-none font-12">Unit Price</th>
                                    </tr>
                                </thead>
                                <tbody className="border-top-0">
                                    {misMatchData?.length && misMatchData.map((v) => (
                                        <tr key={v.ItemNumber}>
                                            <td className="align-middle">
                                                <div className="inventory-product-info">
                                                    <div className="inventory-product-name">
                                                        <NavigateToPDP data={{
                                                            ManufacturerName: CART_PRODUCT_DATA[v?.ERPPartNumber]?.ManufacturerName,
                                                            ERPMFRPartNumber: CART_PRODUCT_DATA[v?.ERPPartNumber]?.ERPMFRPartNumber,
                                                            ItemNumber: CART_PRODUCT_DATA[v?.ERPPartNumber]?.ItemNumber,
                                                        }}>
                                                            <b className='text-black'>{CART_PRODUCT_DATA[v.ERPPartNumber].ERPMFRPartNumber}</b>
                                                        </NavigateToPDP>

                                                    </div>
                                                    <div className="inventory-product-by">
                                                        <DisplayLongDescriptionAndVariantMFRName
                                                            currentProduct={CART_PRODUCT_DATA[v.ERPPartNumber]} />
                                                    </div>
                                                    {v.invMsg && <span className="mandatory">{v.invMsg}</span>}
                                                </div>
                                            </td>
                                            <td className="align-top">
                                                <span>{v.quantity}</span>
                                            </td>
                                            <td className="align-top">
                                                <span>{v.adjustedQuantity}</span>
                                            </td>
                                            <td className="align-top">
                                                <span>{Helper.getFormatNumber(Number(v.adjustedPrice), window.mct, window.mcs, 5)}</span>
                                            </td>
                                        </tr>
                                    ))}
                                    {inventoryData.length ?
                                        <>

                                            <tr className="bg-light">
                                                <th colSpan={4} className='text-center'>INVENTORY ALERT</th>
                                            </tr>
                                            <tr>
                                                <th className="border-0 text-none font-12">Product(s)</th>
                                                <th className="border-0 text-none font-12">Requested Qty</th>
                                                <th className="border-0 text-none font-12">Adjusted Qty</th>
                                                <th className="border-0 text-none font-12">BackOrder Qty </th>
                                            </tr>
                                            {inventoryData.map((v) => (
                                                <tr key={v.ItemNumber}>
                                                    <td className="align-middle">
                                                        <div className="inventory-product-info">
                                                            <div className="inventory-product-name">
                                                                <NavigateToPDP data={{
                                                                    ManufacturerName: CART_PRODUCT_DATA[v?.ERPPartNumber]?.ManufacturerName,
                                                                    ERPMFRPartNumber: CART_PRODUCT_DATA[v?.ERPPartNumber]?.ERPMFRPartNumber,
                                                                    ItemNumber: CART_PRODUCT_DATA[v?.ERPPartNumber]?.ItemNumber,
                                                                }} >
                                                                    <b className='text-black'>{CART_PRODUCT_DATA[v.ERPPartNumber].ERPMFRPartNumber}</b>
                                                                </NavigateToPDP>
                                                            </div>
                                                            <div className="inventory-product-by">
                                                                <DisplayLongDescriptionAndVariantMFRName
                                                                    currentProduct={CART_PRODUCT_DATA[v.ERPPartNumber]} />
                                                            </div>
                                                            <div className="inventory-product-stock"><b>In
                                                                Stock: {v.stock}</b>
                                                            </div>
                                                            <div className="inventory-product-lead">Lead Time From
                                                                Supplier: {getCartProductInventoryLeadTimeByERPPartNumber(v.ERPPartNumber)}
                                                            </div>
                                                            {v.misMatchMsg && <span className="mandatory">{v.misMatchMsg}</span>}
                                                        </div>
                                                    </td>
                                                    <td className="align-top">
                                                        <span>{v.quantity}</span>
                                                    </td>
                                                    <td className="align-top">
                                                        <span>{v.adjustedQuantity}</span>
                                                    </td>
                                                    <td className="align-top">
                                                        <span>{v.adjustedQuantity}</span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </> : null
                                    }
                                </tbody>
                            </table>
                            <div className='text-end'><p>Item Subtotal: (EUR) <strong>€577,60</strong> </p> </div>
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer justify-content-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary btn-sm w145"
                                data-bs-toggle="modal" data-bs-target="#InventoryModal"
                                onClick={() => { onHide(false) }}>
                                No
                            </button>
                            <button type="button" className="bs5 btn btn-primary btn-sm w145"
                                onClick={async () => { await updateQty() }}
                                data-bs-toggle="modal" data-bs-target="#InventoryModal">
                                Yes
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default CartPriceMisMatchBackOrder;